import React from 'react'
import { useTheme, makeStyles, Typography } from '@material-ui/core'
import { styles } from './breadcrumbLink.styles'
import { Link, useHistory } from 'react-router-dom'
import { getTextSnippet } from '../../../helpers/stringHelper'
import { SubjectModel } from '../../../pages/clients/clients.model'
import { SubjectProps, getLinkClientText } from '../../../pages/clients/client.helper'
import { useConfirmationDialog } from '../../../hooks'
import { ConfirmationDialogs } from '../../../model/enums/confirmationDialogs'

export type BreadcrumbLinkProps = {
  toPathName: string
  children: any
  state?: any
  hasPermission?: boolean
  disabled?: boolean
  confirmation?: boolean
}

export interface ClientLinkProps {
  subject: SubjectProps
  contract?: never
}

export interface ContractLinkProps {
  subject?: never
  contract: string
}

export const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = ({
  children,
  toPathName,
  state,
  hasPermission = true,
  disabled = false,
  confirmation = false
}) => {
  const history = useHistory()
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  if (!hasPermission) {
    return null
  }

  const handleClick = async () => {
    if (confirmation) {
      await getConfirmation(ConfirmationDialogs.CANCEL_PENDING_CHANGES).then(value => {
        history.push(toPathName, state)
      })
      closeConfirmation()
    } else {
      history.push(toPathName, state)
    }
  }

  return (
    // <Link
    //   className={classes.breadCrumbLinks}
    //   to={{
    //     pathname: toPathName,
    //     state: state
    //   }}
    // >
    <Typography variant="subtitle2" className={classes.breadCrumbLinks} onClick={handleClick}>
      {children}
    </Typography>
    // </Link>
  )
}
